import {useContext, useEffect, useState} from "react";
import {PageContext, ToastContext, UserContext} from "../../contexts";
import {useNavigate} from "react-router";
import {Outlet} from "react-router-dom";
import Logo from "../../assets/img/logo-h.png";
import LogoG from "../../assets/img/logo.png";
import LogoItweb from "../../assets/img/itweb.png";
import {
  FaBars, FaBell, FaBusinessTime, FaEnvelopeOpenText, FaHome,
  FaRegNewspaper, FaRegUserCircle, FaSignOutAlt, FaTimes,
  FaUserCircle, FaUsers
} from "react-icons/fa";
import {NotificacaoApi, MainApi} from "../../apis";
import useWindowDimensions from "../../hooks/useWindowDimensions";

const QTD_NOTIFICACAO = 5;

export const Main = () => {
  const {user, setUser} = useContext(UserContext);
  const {pageInfo} = useContext(PageContext);
  const toasts = useContext(ToastContext);

  const [notificacao, setNotificacao] = useState(false);
  const [modalNotificacao, setModalNotificacao] = useState(false);
  const [notificacoes, setNotificacoes] = useState(null);
  const [qtdNotificacao, setQtdNotificacao] = useState(QTD_NOTIFICACAO);
  const navigate = useNavigate();
  const [carregado, setCarregado] = useState(false);
  const [menu, setMenu] = useState(false);
  const {width} = useWindowDimensions();
  const [menuAvatar, setMenuAvatar] = useState(false);
  const [numeroNotificacao, setNumeroNotificacao] = useState(0);
  const [searchText, setSearchText] = useState('');
  const [searchResult, setSearchResult] = useState(null);

  const AddToast = (item) => {
    let tempArr = [...toasts.toast];
    tempArr.push(item);
    toasts.setToast({toast: tempArr, setToast: toasts.setToast});
  }

  const search = async () => {
    try {
      let buscaResult = await MainApi.search(user.uuid, searchText);
      if (!buscaResult.error) {
        setSearchResult(buscaResult.data);
      } else {
        AddToast({texto:buscaResult.error, tipo: "erro"});
      }
    } catch (e) {
      AddToast({texto: e, tipo: "erro"});
    }
  }

  useEffect(() => {
    search();
  }, [searchText]);

  const loadNotificacoes = async () => {
    try {
      let resultadoNotificacoes = await NotificacaoApi.getAll(user.uuid, qtdNotificacao);
      if (!resultadoNotificacoes.error) {
        setNotificacoes(resultadoNotificacoes.data);
      } else {
        AddToast({texto: resultadoNotificacoes.error, tipo: "erro"});
      }
    } catch (e) {
      AddToast({texto: e, tipo: "erro"});
    }
  }

  const checkAlertaNotificacao = () => {
    let tem = false;
    let num = 0;
    if (notificacoes) {
      for (let i = 0; i < notificacoes.length; i++) {
        if (!notificacoes[i].visto) {
          if (num <= 99) {
            num++
          }
          tem = true;
        }
      }
      setNotificacao(tem);
      setNumeroNotificacao(num);
    }
  }

  useEffect(() => {
    loadNotificacoes()
  }, [qtdNotificacao]);

  useEffect(() => {
    checkAlertaNotificacao();
  }, [notificacoes]);

  if (!carregado) {
    loadNotificacoes();
    setCarregado(true);
  }

  const toggleNotificacoes = () => {
    setModalNotificacao(!modalNotificacao);
    if (!modalNotificacao) {
      setQtdNotificacao(QTD_NOTIFICACAO);
    }
  }

  const visualizarNotificacao = async (index) => {
    if (!notificacoes[index].visto) {
      try {
        let resultadoViewNotificacao = await NotificacaoApi.setView(user.uuid, notificacoes[index].uuid);
        if (!resultadoViewNotificacao.error) {
          loadNotificacoes();
        } else {

        }
      } catch (e) {
        console.log(e);
      }
    }
  }

  const deletarNotificacao = async (index) => {
    try {
      let resultadoDeleteNotificacao = await NotificacaoApi.setDelete(user.uuid, notificacoes[index].uuid);
      if (!resultadoDeleteNotificacao.error) {
        loadNotificacoes();
      } else {
        AddToast({texto: resultadoDeleteNotificacao.error, tipo: "erro"});
      }
    } catch (e) {
      AddToast({texto: e, tipo: "erro"});
    }
  }

  const eventoScroll = (e) => {
    if (e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight) {
      setQtdNotificacao((qtdNotificacao + QTD_NOTIFICACAO));
    }
  }

  const toggleAvatar = () => {
    setMenuAvatar(!menuAvatar);
  }

  const clickSearch = (item) => {
    navigate('/portalcolaborador/load');
    if (item.tipo === 'publicacao') {
      if (user.nivel === 'colaborador') {
        setTimeout(() => navigate('/portalcolaborador/inicio', {state: {search:item.uuid}, replace: true}), 1);
      } else {
        setTimeout(() => navigate('/portalcolaborador/publicacao', {state: {search:item.uuid}, replace: true}), 1);
      }
      setSearchText('');
    } else if (item.tipo === 'notificacao') {
      setTimeout(() => navigate('/portalcolaborador/notificacao', {state: {search:item.uuid}, replace: true}), 1);
      setSearchText('');
    } else if (item.tipo === 'ci') {
      setTimeout(() => navigate('/portalcolaborador/comunicacaointerna', {state: {search:item.uuid}, replace: true}), 1);
      setSearchText('');
    } else {
      setTimeout(() => navigate('/portalcolaborador/user', {state: {search:item.uuid}, replace: true}), 1);
      setSearchText('');
    }
  }

  const logout = () => {
    localStorage.clear();
    setUser(
      {
        uuid: null,
        nome: null,
        nivel: null,
        funcao: null
      }
    );
    navigate('/portalcolaborador/login');
  }

  return (
    <div className="main" onClick={loadNotificacoes}>
      <div className="main-corpo">
        <div className={(width < 800 && menu) ? "ante-menu mobile-ativo" : "ante-menu"}>
          <div className="logo">
            <img src={width > 800 ? Logo : LogoG} alt="Logo Nunes Peixoto"/>
          </div>
          <div className="main-menu">
            <div className="close-menu" onClick={() => setMenu(false)}>
              <FaTimes size={20}/>
            </div>
            <div
              className={document.location.pathname.includes('/portalcolaborador/inicio') ? 'main-menu-item ativo' : 'main-menu-item'}
              onClick={() => {
                navigate('/portalcolaborador/inicio');
                setMenu(false);
              }}>
              <div className="box-anterior"></div>
              <div className="icone">
                <FaHome size={20}/>
              </div>
              <span className="texto">Início</span>
              <div className="box-posterior"></div>
            </div>

            {(user.nivel === "rh" || user.nivel === "admin" || user.nivel === "sadmin") &&
              <div
                className={document.location.pathname.includes('/portalcolaborador/publicacao') ? 'main-menu-item ativo' : 'main-menu-item'}
                onClick={() => {
                  navigate('/portalcolaborador/publicacao');
                  setMenu(false);
                }}>
                <div className="box-anterior"></div>
                <div className="icone">
                  <FaRegNewspaper size={20}/>
                </div>
                <span className="texto">Publicações</span>
                <div className="box-posterior"></div>
              </div>
            }

            {(user.nivel === "lider" || user.nivel === "rh" || user.nivel.includes("admin")) &&
              <div
                className={document.location.pathname === '/portalcolaborador/comunicacaointerna' ? 'main-menu-item ativo' : 'main-menu-item'}
                onClick={() => {
                  navigate('/portalcolaborador/comunicacaointerna');
                  setMenu(false);
                }}>
                <div className="box-anterior"></div>
                <div className="icone">
                  <FaEnvelopeOpenText size={20}/>
                </div>
                <span className="texto">Relatório Interno</span>
                <div className="box-posterior"></div>
              </div>
            }

            {(user.nivel === "lider" || user.nivel === "admin" || user.nivel === "sadmin") &&
              <div
                className={document.location.pathname === '/portalcolaborador/comunicacaointerna/edit' ? 'main-menu-item ativo' : 'main-menu-item'}
                onClick={() => {
                  navigate('/portalcolaborador/comunicacaointerna/edit');
                  setMenu(false);
                }}>
                <div className="box-anterior"></div>
                <div className="icone">
                  <FaEnvelopeOpenText size={20}/>
                </div>
                <span className="texto">Comunicação Interna</span>
                <div className="box-posterior"></div>
              </div>
            }

            {(user.nivel === "lider" || user.nivel.includes("admin")) &&
              <div
                className={document.location.pathname === '/portalcolaborador/bancodehoras' ? 'main-menu-item ativo' : 'main-menu-item'}
                onClick={() => {
                  navigate('/portalcolaborador/bancodehoras');
                  setMenu(false);
                }}>
                <div className="box-anterior"></div>
                <div className="icone">
                  <FaBusinessTime size={20}/>
                </div>
                <span className="texto">Relatório de Horas</span>
                <div className="box-posterior"></div>
              </div>
            }

            {(user.nivel === "lider" || user.nivel === "admin" || user.nivel === "sadmin") &&
              <div
                className={document.location.pathname === '/portalcolaborador/bancodehoras/edit' ? 'main-menu-item ativo' : 'main-menu-item'}
                onClick={() => {
                  navigate('/portalcolaborador/bancodehoras/edit');
                  setMenu(false);
                }}>
                <div className="box-anterior"></div>
                <div className="icone">
                  <FaBusinessTime size={20}/>
                </div>
                <span className="texto">Banco de Horas</span>
                <div className="box-posterior"></div>
              </div>
            }

            {(user.nivel === "rh" || user.nivel === "admin" || user.nivel === "sadmin") &&
              <div
                className={document.location.pathname.includes('/portalcolaborador/notificacao') ? 'main-menu-item ativo' : 'main-menu-item'}
                onClick={() => {
                  navigate('/portalcolaborador/notificacao');
                  setMenu(false);
                }}>
                <div className="box-anterior"></div>
                <div className="icone">
                  <FaBell size={20}/>
                </div>
                <span className="texto">Notificações</span>
                <div className="box-posterior"></div>
              </div>
            }

            {(user.nivel === "admin" || user.nivel === "sadmin") &&
              <div
                className={document.location.pathname.includes('/portalcolaborador/user') ? 'main-menu-item ativo' : 'main-menu-item'}
                onClick={() => {
                  navigate('/portalcolaborador/user');
                  setMenu(false);
                }}>
                <div className="box-anterior"></div>
                <div className="icone">
                  <FaUsers size={20}/>
                </div>
                <span className="texto">Usuários</span>
                <div className="box-posterior"></div>
              </div>
            }

            <div className='main-menu-item' onClick={logout}>
              <div className="box-anterior"></div>
              <div className="icone">
                <FaSignOutAlt size={20}/>
              </div>
              <span className="texto">Sair do sistema</span>
              <div className="box-posterior"></div>
            </div>

            <a className="logo-itweb" href="https://itweb.net.br" target="_blank" rel="noreferrer">
              <img src={LogoItweb} alt="Itweb Publicidade"/>
            </a>
          </div>
        </div>
        <div className="segundo-espaco" style={(width < 800 && menu) ? {display: "none"} : {}}>
          <div className="corpo">
            <div className="barra-superior">
              <div className="lado-e">
                <div className="hamburguer" onClick={() => {
                  setMenu(true)
                }}>
                  <FaBars size={25}/>
                </div>
                <div className="titulo-maior">
                  {pageInfo.icone}
                  {pageInfo.titulo}
                </div>
              </div>
              <div className="meio">
                <div className="search-global">
                  <input
                    type="text"
                    placeholder="Está procurando por algo?"
                    value={searchText}
                    onChange={(t) => {setSearchText(t.target.value);}}
                  />
                  {searchText && <div className="search-clear" onClick={() => setSearchText('')}><FaTimes size={20}/></div>}
                  {searchText !== '' &&
                    <div className="search-box">
                      {searchResult && searchResult.map((item) => (
                        <div className="search-result-item" onClick={() => clickSearch(item)} key={item.uuid}>
                          <div className="avatar">
                            {item.tipo === 'publicacao' && <FaRegNewspaper size={30}/>}
                            {item.tipo === 'notificacao' && <FaBell size={30}/>}
                            {item.tipo === 'ci' && <FaEnvelopeOpenText size={30}/>}
                            {item.tipo === 'user' && (item.avatar ? <img src={item.avatar} alt="avatar"/> : <FaRegUserCircle size={30}/>)}
                          </div>
                          <div className="texto">
                            <span className="titulo">{item.titulo}</span>
                            <span className="data">{item.criado}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  }
                </div>
              </div>
              <div className="lado-d">
                <div className="notificacoes" onClick={toggleNotificacoes}>
                  <FaBell size={25}/>
                  {notificacao &&
                    <div className="notificacao">
                      <span className="numero-notificacao">{numeroNotificacao}</span>
                    </div>
                  }
                  {modalNotificacao &&
                    <div className="modal-notificacoes">
                      <h4>Notificações</h4>
                      <div className="scroll-notificacoes" onScroll={(e) => eventoScroll(e)}>
                        {notificacoes && notificacoes.map((item, index) => (
                          <div
                            className="notificacao-item"
                            style={!item.visto ? {backgroundColor: "#cfe2ff"} : {backgroundColor: "#fefefe"}}
                            onMouseEnter={() => visualizarNotificacao(index)}
                          >
                            <div className="info">
                              <span className="data">{item.data}</span>
                              <span className="texto">{item.texto}</span>
                            </div>
                            <div className="delete-notificacao" onClick={() => deletarNotificacao(index)}>
                              <FaTimes/>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  }
                </div>
                <div className="topo-avatar" onClick={toggleAvatar}>
                  <div className="avatar">
                    {user.avatar ? <img src={user.avatar} alt={user.nome}/> : <FaUserCircle size={30}/>}
                  </div>
                  <div className="avatar-info">
                    <span className="nome">{user.nome}</span>
                    <span className="funcao">{user.funcao}</span>
                  </div>
                </div>
              </div>
              <div className="mobile">
                <div className="search-global">
                  <input
                    type="text"
                    placeholder="Está procurando por algo?"
                    value={searchText}
                    onChange={(t) => {setSearchText(t.target.value);}}
                  />
                  {searchText && <div className="search-clear" onClick={() => setSearchText('')}><FaTimes size={20}/></div>}
                  {searchText !== '' &&
                    <div className="search-box">
                      {searchResult && searchResult.map((item) => (
                        <div className="search-result-item" onClick={() => clickSearch(item)} key={item.uuid}>
                          <div className="avatar">
                            {item.tipo === 'publicacao' && <FaRegNewspaper size={30}/>}
                            {item.tipo === 'notificacao' && <FaBell size={30}/>}
                            {item.tipo === 'ci' && <FaEnvelopeOpenText size={30}/>}
                            {item.tipo === 'user' && (item.avatar ? <img src={item.avatar} alt="avatar"/> : <FaRegUserCircle size={30}/>)}
                          </div>
                          <div className="texto">
                            <span className="titulo">{item.titulo}</span>
                            <span className="data">{item.criado}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  }
                </div>
              </div>
            </div>
            <Outlet/>
          </div>
        </div>
      </div>
    </div>
  )
}